<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="center">
                    <div class="strong">{{customTitle}}</div>
                    <div class="back-icon" @click="goBack">
                        <img :src="back" alt="">
                    </div>
                </div>
            </nav>
            <div class="content-block">
                <div class="center">
                    <h4 class="content-title">{{customTitle}}</h4>
                    <h6 class="content-sub-title">{{lang.pubAt}} : {{customTime}}</h6>
                    <div class="content custom-content editor-gen" v-html="customContent"></div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import backSrc from '@/style/back.png';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
// import ajax from '@/utils/ajax';
import gDate from '@/utils/format/gDate';
import router from '@/router';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            customTitle: '',
            customTime: '',
            customContent: '',
        };
    },
    mounted() {
        const self = this;
        const getMessage = (event) => {
            console.log(event);
            if (!event.data.pressPage) return;
            const result = event.data;
            self.customTitle = self.isCn ? result.data.cnName : result.data.enName;
            self.customContent = self.isCn ? result.data.contentChina : result.data.contentEng;
            self.customTime = gDate.datetimeFormat(result.data.pubDate, 'YYYY-MM-DD');
            window.removeEventListener('message', getMessage);
        };
        window.addEventListener('message', getMessage, false);
        if (window.opener) {
            window.opener.postMessage('pressReady');
        }
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F8FAF9;
    }
    .back-nav {
        width: 100%;
        height: 64px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        border-bottom: 8px solid #F8FAF9;
        .center {
            width: 960px;
            margin: 0 auto;
            position: relative;
        }
        .back-icon {
            width: 11px;
            height: 16px;
            margin-top: 24px;
            margin-left: 2px;
            z-index: 3;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 32px;
            font-size: 16px;
            color: #4A4A4A;
            text-align: center;
            line-height: 64px;
            font-weight: 500;
        }
    }
    .center {
        width: 960px;
        margin: 0 auto;
    }
    .content-title {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        padding: 0 16px 24px;
        word-break: break-word;
    }
    .content-sub-title {
        text-align: center;
        font-size: 14px;
        padding: 0 16px 40px;
    }
    .content-block {
        background: #fff;
        padding: 40px 0;
    }
</style>
